// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminNotificationPanel from "../../components/dashboard/AdminNotificationPanel";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminNotificationPanel />
    </DashboardLayout>
  );
}
